<template>
  <div class='content-page' v-loading='loading'>
    <LeftTree routerType='real' :treeData='treeData' :deviceList='deviceList' :noMoreFlag='noMoreFlag'
              :checkData='checkData' :optionArray='optionArray' @searchMore='searchMore' :rightArray='rightArray'
              @searchDevie='searchDevie' @treeSearch='treeSearch'>
      <template v-slot:status-name>
        <Tabs :tabs='tabs' :activeCom.sync='activeCom' :stretch='true' @handleTabs='searchStatus' />
      </template>
    </LeftTree>
    <RightContent :rightArray='rightArray' :getCheckArray='getCheckArray' @handleRefresh='handleRefresh' />

    <sensorDetailDialog :show.sync='sensorDetailShow'></sensorDetailDialog>
    <gatewayDetailDialog :show.sync='gatewayDetailShow'></gatewayDetailDialog>
    <displayDetailDialog :show.sync='displayDetailShow'></displayDetailDialog>
    <relayDetailDialog :show.sync='relayDetailShow'></relayDetailDialog>
  </div>
</template>

<script>
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog.vue'
import Tabs from '../components/Tabs.vue'
import LeftTree from '../components/LeftContent.vue'
import RightContent from './RightContent.vue'
import bus from '@/utils/bus'
import { shareTree } from '@/api/modules/public.js'
import {
  monitorGetBatchDeviceInfo,
  monitorGetDeviceInfo,
  monitorGetDeviceList,
  monitorLst
} from '@/api/modules/dataBoard.js'
import { multiCarrierFormat } from '@/utils/multiCarrier'
import { ENUM_RE_DEVICE_TYPE } from '@/common/enum/reverse/device'
import { ENUM_DEVICE_TYPE } from '@/common/enum/forward/device'

export default {
  components: {
    Tabs,
    LeftTree,
    RightContent,
    sensorDetailDialog,
    gatewayDetailDialog,
    displayDetailDialog,
    relayDetailDialog
  },
  data () {
    return {
      // 详情
      sensorDetailShow: false,
      gatewayDetailShow: false,
      displayDetailShow: false,
      relayDetailShow: false,
      // 监测点树
      treeData: [],
      tabs: [
        {
          label: $t('public.All'),
          name: 'all',
          status: ''
        },
        {
          label: $t('public.online'),
          name: 'onLine',
          status: 1
        },
        {
          label: $t('public.offline'),
          name: 'outLine',
          status: 0
        },
        {
          label: $t('public.stop'),
          name: 'stop',
          status: 2
        }
      ],
      optionArray: [
        {
          label: $t($t('integration.equipment_type')),
          value: '',
          icon: 'iconfont icon-zhunbeiliangchan'
        },
        {
          label: $t('public.sensor'),
          value: '0',
          icon: 'iconfont icon-chuanganqi1'
        },
        {
          label: $t('public.gateway'),
          value: '1',
          icon: 'iconfont icon-wangguan'
        },
        {
          label: $t('public.display'),
          value: '2',
          icon: 'iconfont icon-lcd'
        },
        {
          label: $t('public.relay'),
          value: '3',
          icon: 'el-icon-s-operation'
        },
        // 增加气体和门磁
        {
          label: $t('route.gas'),
          value: '5',
          icon: 'iconfont icon-qiti'
        },
        {
          label: $t('route.magnetism'),
          value: '6',
          icon: 'iconfont icon-menci'
        }
      ],
      activeCom: 'all',
      // 列表参数
      query: {
        iDisplayStart: 0,
        iDisplayLength: 20,
        status: '',
        devCatalog: '',
        carrierId: '',
        devName: '',
        sceneId: ''
      },
      // 设备列表
      deviceList: [],
      noMoreFlag: false,
      // 设备选中数据
      checkData: [],
      // 勾选列表请求数据set到右侧
      getCheckArray: {},
      // 右侧详情数据
      rightArray: [],
      loading: false
    }
  },
  created () {
    this.getInitData()
  },
  mounted () {
    // 全选框的请求
    bus.$on('selectAll', bool => {
      // console.log(this.rightArray);
      // 需要排除已经存储在数据库的内容 && 单选中的数据
      let restArray = []
      if (bool) {
        restArray = this.setArray(this.deviceList, this.rightArray).map(opt => ({
          deviceCatalog: opt.deviceCatalog,
          deviceId: opt.deviceId,
          deviceType: opt.deviceType
        }))
      }
      this.getSelectAll(restArray, bool)
    }),
    // 单选框
    bus.$on('SelectRow', obj => {
      if (obj.isSelected) {
        let flag = false
        this.rightArray.forEach(op => {
          if (obj.row.deviceId === op.param.id && op.deviceCatalog === obj.row.deviceCatalog) {
            flag = true
          }
        })
        if (flag) return this.$message.warning($t('integration.this_device_already_exists'))
        monitorGetDeviceInfo({
          devCatalog: obj.row.deviceCatalog,
          devId: obj.row.deviceId
        }).then(({ result }) => {
          // const array = this.generArray(result)
          // 设备类型
          const code = ENUM_RE_DEVICE_TYPE[result.deviceCatalog].code
          this.rightArray.push({
            deviceCatalog: result.deviceCatalog,
            param: result.deviceCatalog === ENUM_DEVICE_TYPE.DISPLAY || result.deviceCatalog === ENUM_DEVICE_TYPE.GATEWAY ? this.disFn(result[code]) : result[code]
          })
          // console.log(this.rightArray)
        })
      } else {
        this.rightArray = this.rightArray.filter(item => item.param.id !== obj.row.deviceId)
      }
    })
    bus.$on('cancelCheck', id => {
      this.rightArray = this.rightArray.filter(item => item.param.id !== id)
    })
  },
  beforeDestroy () {
    bus.$off('selectAll')
    bus.$off('SelectRow')
    bus.$off('cancelCheck')
  },
  methods: {
    async getInitData () {
      this.loading = true

      const { result } = await shareTree({
        carrier: true,
        addAllNode: false
      })
      this.treeData = (result && result.item) || []
      this.query.sceneId = this.treeData[0].scopeId
      // 查列表
      this.getListFn()
      // 查右侧详情
      this.getDeviceDetail()
    },
    getListFn () {
      monitorLst(this.query).then(({ result }) => {
        const {
          deviceMonitorList,
          page
        } = result
        if (this.query.iDisplayStart === 0) {
          this.deviceList = page.result ? page.result : []
        } else {
          this.deviceList = [...this.deviceList, ...page.result]
        }

        // console.log('deviceList==>', this.deviceList)
        this.noMoreFlag = this.deviceList.length === page.pageInfo.total
        this.checkData = deviceMonitorList || []
      })
    },
    quChong (arrObj) {
      const map = new Map()
      for (const item of arrObj) {
        if (!map.has(item.id)) {
          map.set(item.param.id, item)
        }
      }
      return [...map.values()]
    },
    getDeviceDetail () {
      monitorGetDeviceList()
        .then(({ result }) => {
          this.rightArray = this.quChong(this.rightArray.concat(this.changeParam(result)))
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 统一属性名称修改 将数组中的每个对象的第二项统一命名为param
    changeParam (array = []) {
      return array.map(item => {
        const code = ENUM_RE_DEVICE_TYPE[item.deviceCatalog].code
        const param = item.deviceCatalog === ENUM_DEVICE_TYPE.DISPLAY || item.deviceCatalog === ENUM_DEVICE_TYPE.GATEWAY ? this.disFn(item[code]) : item[code]
        return {
          deviceCatalog: item.deviceCatalog,
          param
        }
      })
    },
    disFn (item) {
      const dataInfo = {};
      (item.carrierRspList || []).forEach((item, index) => {
        const {
          structureId,
          sceneName,
          fullPath
        } = item
        if (!dataInfo[structureId]) {
          dataInfo[structureId] = {
            sceneName,
            structureId,
            fullPath,
            child: []
          }
        }
        dataInfo[structureId].child.push(item)
      })
      const list = Object.values(dataInfo) // list 转换成功的数据
      item.carrierList = { ...item.carrierRspList }
      item.carrierRspList = list
      return multiCarrierFormat(item)
    },
    // 点击查询更多
    searchMore () {
      this.query.iDisplayStart += 20
      this.getListFn()
    },
    // 状态查询
    searchStatus ({ status }) {
      this.deviceList = []
      this.checkData = []
      this.query.status = status
      this.getListFn()
    },
    // 设备查询
    searchDevie (row) {
      this.deviceList = []
      this.checkData = []
      this.query.devName = row.inputValue
      this.query.devCatalog = row.devCatalog
      this.query.iDisplayStart = 0
      this.query.iDisplayLength = 20
      this.getListFn()
      this.getDeviceDetail()
    },
    // 树形查询
    treeSearch ({
      id,
      carrierId
    }) {
      this.query.iDisplayStart = 0
      this.query.iDisplayLength = 20
      this.deviceList = []
      this.checkData = []
      this.query.sceneId = id
      this.query.carrierId = carrierId
      this.$nextTick(() => {
        this.getListFn()
        this.getDeviceDetail()
      })
    },
    // 两个对象数组去重
    setArray (oldArray = [], newArray = []) {
      return oldArray.filter(item => !newArray.some(ele => ele.param.id === item.deviceId))
    },

    getSelectAll (allArray = [], bool) {
      if (!bool) {
        this.rightArray = this.rightArray.filter(item => !this.deviceList.some(ele => ele.deviceId === item.param.id))
        return
      }
      monitorGetBatchDeviceInfo(allArray).then(({ result }) => {
        if (result.length === 0) return (this.rightArray = [])
        this.rightArray = this.rightArray.concat(this.changeParam(result))
      })
    },
    generArray (result) {
      const array = []
      for (const key in result) {
        array.push(result[key])
      }
      return array
    },
    // 刷新
    handleRefresh () {
      this.deviceList = []
      this.checkData = []
      this.getListFn()
      this.getDeviceDetail()
    }
  }
}
</script>

<style lang='scss' scoped>
.content-page {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
